<template>
  <div :class="['carrousel', { 'carrousel--grabbing': grabbing }]" v-in-viewport v-on:mousedown="grabbing=true"  v-on:mouseup="grabbing=false">
    <slot />
  </div>
</template>

<style lang="scss">
.carrousel{
  position: relative;
  overflow: hidden;
  cursor: grab;

  &--left{
    text-align: left;
  }
  &--right{
    text-align: right;
    @media #{$bp-sm}{
      margin-right: 2rem;
    }
  }

  &--reconstruire{
    width: calc( 100% - 18rem );
    margin-left: auto;
    @media #{$bp-sm}{
      width: calc( 100% - 2rem );
      margin-bottom:6rem;
    }
  }

  &--grabbinf{
    cursor: grabbing;
  }
  
  &__item{
    max-width: 65%;
    color: white;
    @media #{$bp-sm}{
      max-width: 80%;
    }

    .title-h2{
      span{
        color: white;
      }
    }

    &--reconstruire{
      width: 74rem;
    }
      
    &:first-child{
      display: inline-block;
    }
    
    &:not(:first-child){
      position: absolute;
      top: 0;
      .carrousel--right & {
        right: 0;
      }
      .carrousel--left & {
        left: 0;
      }
    }
  }

  img{
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-user-drag: none;
    -moz-user-drag: none;
    user-drag: none;
  }
}
</style>

<script>
import Carrousel from './Carrousel'

export default {
  data() {
    return {
      grabbing: false
    };
  },
  methods: {

  },
  beforeDestroy(){
    this.carrousel.kill()
  },
  mounted(){
    this.carrousel = new Carrousel( this.$el )
  }
};
</script>
